module.exports = __webpack_public_path__ + "img/Marca17.ce7929e6.jpg";